import { render, staticRenderFns } from "./view.vue?vue&type=template&id=c8995cc0"
import script from "./view.ts?vue&type=script&lang=js&external"
export * from "./view.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8995cc0')) {
      api.createRecord('c8995cc0', component.options)
    } else {
      api.reload('c8995cc0', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=c8995cc0", function () {
      api.rerender('c8995cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/statusSistema/view.vue"
export default component.exports